module.exports = __webpack_public_path__ + "static/SPELL-02a6d9cfcfc35968b0f8934df393c62b.svg";